<script lang="ts">
	import EnergyCircleText from './EnergyCircleText.svelte';

	type Keys = 'grid' | 'solar' | 'home' | 'battery';

	export let type: Keys,
		value: string,
		x = 0,
		y = 0,
		titleTop = false,
		radius: number,
		strokeWidth: number,
		textHeight = 40,
		margin: number;

	const titleY = titleTop ? 10 : radius * 2 + textHeight,
		valueY = 62 + margin;
</script>

<g fill="white" transform="translate({`${x} ${y}`})">
	<circle
		cx={radius + strokeWidth / 2}
		cy={radius + strokeWidth / 2 + margin}
		r={radius}
		stroke="white"
		stroke-width={strokeWidth}
		fill="transparent"
	/>
	{#if type == 'grid'}
		<path
			transform="translate(28, 38) scale(1.2)"
			d="M8.28,5.45L6.5,4.55L7.76,2H16.23L17.5,4.55L15.72,5.44L15,4H9L8.28,5.45M18.62,8H14.09L13.3,5H10.7L9.91,8H5.38L4.1,10.55L5.89,11.44L6.62,10H17.38L18.1,11.45L19.89,10.56L18.62,8M17.77,22H15.7L15.46,21.1L12,15.9L8.53,21.1L8.3,22H6.23L9.12,11H11.19L10.83,12.35L12,14.1L13.16,12.35L12.81,11H14.88L17.77,22M11.4,15L10.5,13.65L9.32,18.13L11.4,15M14.68,18.12L13.5,13.64L12.6,15L14.68,18.12Z"
		/>
	{:else if type == 'home'}
		<path transform="translate(28, 40) scale(1.2)" d="M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z" />
	{:else if type == 'solar'}
		<path
			transform="translate(28, 40) scale(1.2)"
			d="M 11.45 2 V 5.55 L 15 3.77 L 11.45 2 M 10.45 8 L 8 10.46 L 11.75 11.71 L 10.45 8 M 2 11.45 L 3.77 15 L 5.55 11.45 H 2 M 10 2 H 2 V 10 C 2.57 10.17 3.17 10.25 3.77 10.25 C 7.35 10.26 10.26 7.35 10.27 3.75 C 10.26 3.16 10.17 2.57 10 2 M 17 22 V 16 H 14 L 19 7 V 13 H 22 L 17 22 Z"
		/>
	{:else if type == 'battery'}
		<path
			transform="translate(30, 40) scale(0.05)"
			d="M80 96c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32l96 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32h16c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64l16 0zm304 96c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H320c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V256h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H384V192zM80 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16z"
		/>
	{/if}
	<EnergyCircleText x={radius + strokeWidth / 2} y={valueY} {value} />
	<EnergyCircleText x={radius + strokeWidth / 2} y={titleY} value={type} fontSize={15} type="title" />
</g>
